hrd.utils.export.ExcelExporter = hrd.utils.export.AbstractExporter.extend({
	init: function(tableManager, options) {
		var defaults = {
			impl: 'hrd.utils.export.ExcelExporter'
		};
		this._super(tableManager, $.extend({}, defaults, options));
	},
	getExtension: function() {
		return 'xls';
		//return 'xml';
	},
	getDataTypePrefix: function() {
		return "data:application/vnd.ms-excel;charset=utf-8,";
	},
	export: function() {
		let settings = this.tableInstance.fnSettings();
		let columns = settings.aoColumns;
		let prefix = this.getDataTypePrefix();
		let headerData = this.exportHeader(columns);
		let rowsData = this.exportRows(columns);

		let header = `<?xml version="1.0" encoding="windows-1252"?><?mso-application progid="Excel.Sheet"?>`;
		let workbookOpen = `<Workbook 
	xmlns="urn:schemas-microsoft-com:office:spreadsheet" 
	xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet" 
	xmlns:o="urn:schemas-microsoft-com:office:office" 
	xmlns:x="urn:schemas-microsoft-com:office:excel" 
	xmlns:html="http://www.w3.org/TR/REC-html40">`;
		let workbookClose = `</Workbook>`;

		let documentProperties = `<DocumentProperties xmlns="urn:schemas-microsoft-com:office:office">
		<Author>Jera Exporter</Author>
		<Created>${moment().format('x')}</Created>
	</DocumentProperties>`;

		let styles = this.prepareStyles();
		let columnsDef = this.prepareColumns(columns);

		let contentData = `${header}
${workbookOpen}
	${documentProperties}
	${styles}
	<Worksheet ss:Name="Sheet 1">
		<ss:Table>
			${columnsDef}${headerData}${rowsData}
		</ss:Table>
	</Worksheet>
${workbookClose}`;
		this.downloadFileFn(prefix, contentData);
	},
	prepareStyles: function() {
		return `<ss:Styles>
		<ss:Style ss:ID="Default" ss:Name="Normal">
			<ss:NumberFormat/>
		</ss:Style>
		<ss:Style ss:ID="Header">
			<ss:Alignment ss:Horizontal="Center" ss:Indent="0" ss:Vertical="Center"/>
			<ss:Borders>
				<ss:Border ss:Color="#000000" ss:Weight="1" ss:LineStyle="Continuous" ss:Position="Right"/>
				<ss:Border ss:Color="#000000" ss:Weight="1" ss:LineStyle="Continuous" ss:Position="Left"/>
				<ss:Border ss:Color="#000000" ss:Weight="1" ss:LineStyle="Continuous" ss:Position="Top"/>
				<ss:Border ss:Color="#000000" ss:Weight="1" ss:LineStyle="Continuous" ss:Position="Bottom"/>
			</ss:Borders>
			<ss:Font ss:Size="10" ss:Color="#000000"/>
			<ss:Interior ss:Color="#c6c6c6" ss:Pattern="Solid"/>
		</ss:Style>
		<ss:Style ss:ID="Decimals">
			<ss:NumberFormat ss:Format="Fixed"/>
		</ss:Style>
		<ss:Style ss:ID="Amount">
			<ss:NumberFormat ss:Format="#,##0.00"/>
		</ss:Style>
		<ss:Style ss:ID="Percent">
			<ss:NumberFormat ss:Format="#,##0.00%"/>
		</ss:Style>
		<ss:Style ss:ID="Date">
			<ss:NumberFormat ss:Format="DD/MM/YYYY"/>
		</ss:Style>
	</ss:Styles>`;
	},
	prepareColumns: function(columns) {
		let header = columns
			.filter(col => this.exportableColumn(col))
			.map(col => this.getColumnTitle(col))
			.map(title => this.toolbox.isNotEmpty(title) ? title.length : 0)
			.map(l => l * 6.50)
			.map(w => `<ss:Column ss:AutoFitWidth="1" ss:Width="${w}"/>`)
			.join('\r\n\t\t\t');
		return header;
	},
	exportHeader: function(columns) {
		let header = columns
			.filter(col => this.exportableColumn(col))
			.map(col => this.getColumnTitle(col))
			.map(cell => `<ss:Cell ss:StyleID="Header"><ss:Data ss:Type="String">${cell}</ss:Data></ss:Cell>`)
			.join('\r\n\t\t\t\t');
		return `
			<ss:Row ss:Height="20">
				${header}
			</ss:Row>`;
	},
	exportRows: function(columns) {
		let rows = this.tableInstance.fnGetData();
		let aRows = rows.map(row => this.exportRow(row, columns)).join('');
		return aRows
	},
	exportRow: function(rowData, columns) {
		let row = columns
			.filter(columnInfo => this.exportableColumn(columnInfo))
			.map(columnInfo => this.extractCell(rowData, columnInfo))
			.join('\r\n\t\t\t\t');
		return `
			<ss:Row>
				${row}
			</ss:Row>`;
	},
	extractCell: function(rowData, columnInfo) {
		let type = this.toolbox.get('export.type', columnInfo, 'string');
		let value = this.extractValue(rowData, columnInfo);
		type = this.toolbox.isEmpty(value) ? 'string' : type;
		let cell;
		switch (type.toLowerCase()) {
			case 'amount':
				value = localeNumberConverter.convert(value);
				cell = `<ss:Cell ss:StyleID="Amount"><ss:Data ss:Type="Number">${value}</ss:Data></ss:Cell>`;
				break;
			case 'date':
				value = moment(value, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss');
				cell = `<ss:Cell ss:StyleID="Date"><ss:Data ss:Type="DateTime">${value}</ss:Data></ss:Cell>`;
				break;
			case 'string':
			default:
				cell = `<ss:Cell><ss:Data ss:Type="String">${value}</ss:Data></ss:Cell>`;
				break;
		}
		return cell;
	}
});